import { type PriceOfferType } from '../services/appointment/model';
import { type CustomerType } from '../reducers/user/userTypes';

export const getLoginLink = (
  currentLocation: string,
  appConfig: typeof CSS_CONFIG,
): string => {
  const { country, language, loginLink } = appConfig;
  const setLocale = (): string => `${country}/${language}`;

  return `${loginLink.replace('LOCALE', setLocale())}?from=${currentLocation}`;
};

export const shouldHideLoginLink = (
  userIsLoggedIn: boolean,
  allowedMemberDiscounts: boolean,
  customerType: CustomerType,
  isBusiness: boolean,
  priceOfferType?: PriceOfferType,
): boolean => {
  if (!priceOfferType || priceOfferType === 'tro') {
    return userIsLoggedIn;
  }
  const isIkeaMembership = userIsLoggedIn && allowedMemberDiscounts;
  return isBusiness
    ? isIkeaMembership && customerType === 'Business'
    : isIkeaMembership;
};
